module.exports = __webpack_public_path__ + "static/media/hpSmartStream.22f9506d.png";